import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/CallToActions/CtaWrapper/ctaWrapper.container"
    ).then((module) => ({
        default: module.CtaWrapper
    }))
);
